export const SCALAR_E7 = 0.0000001;
